import React from 'react'
import './sentryandgolf.scss'
import { Hero, MainHeading, PageHeaderIntro, CommonCard, VideoPlayer, FeaturedBar, LetsTalk } from '../../../components';
import { images } from "../../../utils/customFn";
import { Container } from 'react-bootstrap';
import Data from './data.json';
const Golf = () => {

    const HeaderData = [
        {
            image: images['grouped-logos-sentry-golf.svg'],
            para: 'At Sentry, we’re dedicated to building relationships with the people our insurance helps protect.',
            para1: 'We hold a similar commitment to golf—which allows us to connect with our customers and the communities we’re in. That’s why we partner with the PGA TOUR, USGA, and First Tee.',
            para2: 'Golf reminds us that the strongest relationships begin with integrity and trust—the same values we’ve used to approach our business for 120 years.',
        },
    ];

    const featuredBarData = [
        {
            id: 1,
            title: "We believe in conversation—on and off the course. It’s how we get to know your business.",
            link: "",
            btnText: "Why choose Sentry",
        },
    ];
    const insuranceData = [
        {
            id: 1,
            title: "We offer tailored insurance coverages to help protect your business.",
            link: "",
            btnText: "Business insurance",
        },
    ]

    const theSentry = [
        {
            "id": 1,
            "img": "https://images.ctfassets.net/xgr7yhvqn20n/2RE44YNXR65Oqcb323QSi4/950f515250072caec3398582072ed431/Sentry_Tournament_of_Champions_Blue_Chairs_550x222.jpg?q=75&w=1400&fm=avif",
            "title": "Your guide to the 2025 tournament",
            "description": "As title sponsor of The Sentry, we’re deepening relationships while helping support the Maui community.",
            "linkUrl": "",
            "linkText": "Learn more >"
        },
        {
            "id": 2,
            "img": "https://images.ctfassets.net/xgr7yhvqn20n/5ByNIbsPvboEBgUlJGDGQO/1e9886a90d3f76cc2a86b61d73f90e61/SToC_550x222.jpg?q=75&w=1400&fm=avif",
            "title": "Our commitment to Maui",
            "description": "We were honored to host the 2023 U.S. Senior Open at SentryWorld, our Top 100 nationally ranked public golf course in Stevens Point, WI.",
            "linkUrl": "/",
            "linkText": "Learn more >"
        },
    ]

    const description = [
        {
            para: "Our role as a First Tee trustee is a natural extension of our commitment to grow the game of golf—and support both youth and families in underserved communities. We support First Tee’s focus on curriculum enhancements, technology innovations, and expanding diversity and inclusion efforts."
        }
    ]

    return (
        <>
            <div className='golf-wrapper'>

                {/* hero section */}
                <Hero img={images["Hero_Golf.avif"]} />

                <Container>
                    {/* heading  */}
                    <MainHeading title="Sentry and golf" showshare={false} />

                    {/* page intro */}
                    <PageHeaderIntro heading="Helping us connect with you, and your business" Data={HeaderData} />

                    {/*golf cards*/}
                    <CommonCard Title="Sentry’s commitment to golf" CardData={Data} colSizes={{ lg: 4, xl: 4 }} />

                    {/* video player */}
                    <VideoPlayer Title="Golf: Where conversations start, connections grow" videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />

                    {/* feature bar card */}
                    <FeaturedBar data={featuredBarData} />

                    {/* the sentry cards */}
                    <CommonCard Title="The Sentry" CardData={theSentry} colSizes={{ lg: 6, xl: 6 }} />

                    {/* page intro */}
                    <PageHeaderIntro heading="Sentry and First Tee" Data={description} showImage={false} />

                    {/* video player */}
                    <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />

                    {/* insurance card */}
                    <FeaturedBar data={insuranceData} />

                    {/* the sentry cards */}
                    <CommonCard CardData={theSentry} colSizes={{ lg: 6, xl: 6 }} />

                    {/* lets talk section */}
                    <LetsTalk />
                </Container>
            </div>
        </>
    )
}

export default Golf